$exso_sheets_blowings_class $exso_sheets
	paths / \/api/blowings
	order_by / \date
	state *
		wet @ \Обводненные
		dry @ \Сухие
		unknown \-
	columns *
		date * title @ \Дата
		block * title @ \Блок
		mesh *
			title @ \Сетка скв.
			unit @ \МхМ
		blasted *
			title @ \Объем взорванной массы
			unit @ \м³
		burnt *
			title @ \Обурено
			unit @ \п.м.
		state * title @ \Состояние скважин
		place * title @ \Место
